import { render, staticRenderFns } from "./ProductCustomPropertyEditIframe.vue?vue&type=template&id=30201d6c&"
import script from "./ProductCustomPropertyEditIframe.vue?vue&type=script&lang=ts&"
export * from "./ProductCustomPropertyEditIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports